<div class="account-flyout">
  <div
    fxFlex
    class="account-flyout__nologin"
    (click)="navigateToIdam()"
    (keydown.enter)="navigateToIdam()"
    (keydown.space)="navigateToIdam()"
    role="button"
    tabindex="0"
    [attr.aria-label]="
      ('CORE.ALL_PAGES.USER_BOX.SIGNUP.LABEL' | translate) + '/' + ('CORE.ALL_PAGES.USER_BOX.LOGIN.LABEL' | translate)
    "
  >
    <img loading="lazy" [src]="avatarIcon" class="account-flyout__avatar" width="24" height="24" alt="User avatar" />
    <a [mmTestTarget]="'login-link-desktop'" rel="nofollow" aria-label="Sign up or log in">
      {{ 'CORE.ALL_PAGES.USER_BOX.SIGNUP.LABEL' | translate }}/{{ 'CORE.ALL_PAGES.USER_BOX.LOGIN.LABEL' | translate }}
    </a>
  </div>
</div>
